import { apiRequest } from "@/services/api-client";
import { DequeuePlayerOutput, WebAppRoutes } from "types/web-app";

export const dequeuePlayer = () =>
  apiRequest<DequeuePlayerOutput>(`/${WebAppRoutes.DEQUEUE_PLAYER}`, {
    method: "POST",
  });
